<div class="text-body-secondary text-sm border-top pt-3">
  Intuit and QuickBooks are registered trademarks of Intuit Inc. Used with
  permission.
</div>
